import React from "react";

export default function GameStatusOverlay({ control }) {
  if (control?.enabled !== false && control?.status === "active") return null;
  const status = control?.enabled === false ? "disabled" : control?.status || "maintenance";
  return (
    <div style={{position:"fixed",inset:0,zIndex:2147483647,display:"grid",placeItems:"center",background:"rgba(4,10,20,.96)",color:"#fff",textAlign:"center",padding:24,isolation:"isolate"}}>
      <div>
        <div style={{fontSize:14,letterSpacing:3,color:"#50e3c2",textTransform:"uppercase"}}>Streamfy</div>
        <h1 style={{fontSize:36,margin:"14px 0",textTransform:"capitalize"}}>{status}</h1>
        <p style={{maxWidth:480,color:"#b8c7d9",lineHeight:1.6}}>This game is temporarily unavailable. No bets can be placed while this notice is displayed.</p>
      </div>
    </div>
  );
}
